/** Envoi d'un rapport d'intervention par e-mail. */
import { lazy } from 'react';
import type { AppRoute } from '../../app/route-types.js';

const DocumentEmailPage = lazy(() => import('./DocumentActions.js').then((m) => ({ default: m.DocumentEmailPage })));

export const documentsRoutes: AppRoute[] = [
  { path: '/rapports/:id/envoi-email', element: <DocumentEmailPage kind="report" /> },
];
